import { Controller } from "@hotwired/stimulus";
import Money from "lib/money";

export default class extends Controller {
  static targets = ["card", "submit"]

  quantityChanged() {
    const items = this.#collectItems();
    const hasItems = items.length > 0;

    this.submitTarget.disabled = !hasItems;

    this.cardTargets.forEach(card => {
      const input = card.querySelector('[data-quantity-target="input"]');
      if (input) {
        card.dataset.ticketState = parseInt(input.value) > 0 ? "selected" : "";
      }
    });
  }

  async addToCart() {
    const items = this.#collectItems();
    if (items.length === 0) return;

    const addText = this.submitTarget.dataset.addText;
    const addingText = this.submitTarget.dataset.addingText;

    this.submitTarget.disabled = true;
    this.submitTarget.textContent = addingText;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error("Add to cart failed");

      Turbo.visit(window.location.href, { action: "replace" });
      document.addEventListener("turbo:morph", this.#afterMorph);
    } catch {
      this.submitTarget.disabled = false;
      this.submitTarget.textContent = addText;
    }
  }

  // Private

  #collectItems() {
    return this.cardTargets
      .map(card => {
        const input = card.querySelector('[data-quantity-target="input"]');
        return {
          id: parseInt(card.dataset.variantId),
          quantity: input ? parseInt(input.value) : 0
        };
      })
      .filter(item => item.quantity > 0);
  }

  #afterMorph = () => {
    document.removeEventListener("turbo:morph", this.#afterMorph);
    setTimeout(() => {
      const dialogEl = document.getElementById("cart-drawer");
      const controller = this.application.getControllerForElementAndIdentifier(dialogEl, "dialog");
      if (controller) controller.open();
    }, 50);
  }
}
